import styled from 'styled-components'

const SectionWrapper = styled.section`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 20px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 26px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 40px 20px 20px;
  }
`

const SectionTitle = styled.h2`
  color: black;
  font-size: 48px;
  font-weight: 500;
  text-align: center;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 32px;
  }
`

const SectionSubtitle = styled.div`
  color: #3f3f3f;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  margin: 0;
  max-width: 900px;

  strong {
    font-weight: 700;
  }

  em {
    color: #a5a5a5;
    font-style: italic;
  }

  @media (max-width: 768px) {
    font-size: 16px;
  }
`

const ReviewsHeaderSection = () => {
  return (
    <SectionWrapper>
      <SectionTitle>Loved by Designers & Home Creators.</SectionTitle>
      <SectionSubtitle>
        Join millions of people designing, decorating, and creating real rooms with DecorMatters.
        <br /><br />
        <strong>21,108,745</strong> <em>Designs Created in DecorMatters.</em>
      </SectionSubtitle>
    </SectionWrapper>
  )
}

export default ReviewsHeaderSection
